export default __webpack_public_path__ + "static/media/step_010.6b0c229f.jpeg";